import React from 'react'

function HomePageTextContent() {
  return (
    <div >
    <p
      style={{
        fontFamily:
          "Maersk Text, -apple-system, BlinkMacSystemFont, Microsoft JhengHei, Microsoft Yahei, 微软雅黑, STXihei, 华文细黑, sans-serif",
        fontSize: "40px",
        fontWeight: "400",
        fontStyle: "normal",
        letterSpacing: "0px",
        textAlign: "center",
      }}
    >
      Welcome to the Post-mortem System
    </p>
    <p style={{ textAlign: "center", fontSize:"20px", lineHeight:"30px", fontWeight:"normal", padding:"0 40px" }}>
     Your all-in-one solution for efficient incident understanding, root cause analysis, and proactive disruption prevention. Streamline your post-incident processes and elevate your team's capabilities effortlessly.
    </p>
  </div>
  )
}

export default HomePageTextContent